import React, { ReactNode } from 'react';

import classes from './TimerBlock.module.scss';
import { Timer } from './Timer/Timer';

type TimerBlockProps = {
  expirationEpoch: number;
  description: ReactNode;
};

const TimerBlock = ({ expirationEpoch, description }: TimerBlockProps) => {
  return (
    <div className={classes.container}>
      <Timer expirationEpoch={expirationEpoch} />
      <div className={classes.description}>{description}</div>
    </div>
  );
};

export { TimerBlock };
